var _jsxFileName = "/home/circleci/NACL/NACL/packages/nr-vamp-xl-pizza-tracker/src/PizzaTrackerPure.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck';
import PropTypes from 'prop-types';
import { css } from 'glamor';

var PizzaTrackerPure = function PizzaTrackerPure(_ref) {
  var dataE2E = _ref['data-e2e'],
      id = _ref.id,
      stepItems = _ref.stepItems,
      successIcon = _ref.successIcon,
      styles = _ref.styles;
  return React.createElement("div", _extends({
    "data-e2e": dataE2E,
    id: id
  }, css(styles.container), {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: this
  }), React.createElement(Stepper, {
    "data-e2e": "".concat(dataE2E, "-stepper"),
    id: "".concat(id, "-stepper"),
    alternativeLabel: true,
    classes: {
      root: css(styles.root).toString()
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12
    },
    __self: this
  }, stepItems.map(function (item, i) {
    return React.createElement(Step, {
      "data-e2e": "".concat(dataE2E, "-step-").concat(i),
      id: "".concat(id, "-step-").concat(i)
      /** There's nothing to make a good key from, so falling back to the index */
      // eslint-disable-next-line react/no-array-index-key
      ,
      key: "step-".concat(i),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21
      },
      __self: this
    }, React.createElement(StepLabel, {
      "data-e2e": "".concat(dataE2E, "-step-label-").concat(i),
      id: "".concat(id, "-step-label-").concat(i),
      classes: {
        label: css(styles.label).toString(),
        active: css(styles.activeLabel).toString()
      },
      icon: React.createElement("div", _extends({
        "data-e2e": "".concat(dataE2E, "-step-label-icon-").concat(i),
        id: "".concat(id, "-step-label-icon-").concat(i)
      }, css(styles.stepIcon, item.indicator === 'danger' && styles.stepIconDanger || item.indicator === 'success' && styles.stepIconSuccess || item.indicator === 'warning' && styles.stepIconWarning || styles.stepIconDefault), {
        className: item.indicator,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36
        },
        __self: this
      }), item.indicator === 'success' && React.createElement(FontAwesomeIcon, {
        "data-e2e": "".concat(dataE2E, "-step-label-icon-").concat(i, "-success-icon"),
        icon: successIcon,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49
        },
        __self: this
      })),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28
      },
      __self: this
    }, item.label));
  })));
};

PizzaTrackerPure.propTypes = {
  /** Passed down to all DOM elements to allow E2E testing. */
  'data-e2e': PropTypes.string,

  /** Component ID. */
  id: PropTypes.string,

  /** The array of our statuses to display */
  stepItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
    indicator: PropTypes.oneOf(['danger', 'default', 'success', 'warning'])
  })),

  /** The icon to use in the success indicator */
  successIcon: PropTypes.shape({}),

  /** Applied styles. */
  styles: PropTypes.shape({
    container: PropTypes.shape({}),
    root: PropTypes.shape({}),
    label: PropTypes.shape({}),
    activeLabel: PropTypes.shape({}),
    stepIcon: PropTypes.shape({}),
    stepIconDefault: PropTypes.shape({}),
    stepIconDanger: PropTypes.shape({}),
    stepIconSuccess: PropTypes.shape({}),
    stepIconWarning: PropTypes.shape({})
  })
};
PizzaTrackerPure.defaultProps = {
  'data-e2e': null,
  id: null,
  stepItems: [],
  successIcon: faCheck,
  styles: {
    container: {},
    root: {},
    label: {},
    activeLabel: {},
    stepIcon: {},
    stepIconDefault: {},
    stepIconDanger: {},
    stepIconSuccess: {},
    stepIconWarning: {}
  }
};
PizzaTrackerPure.displayName = 'PizzaTrackerPure';
export default PizzaTrackerPure;